import { createStore } from 'redux';
import namingReducer from '../reducers/naming_reducer.js';

const store = createStore(namingReducer);

export default store;
